"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _state = _interopRequireDefault(require("@/libs/state"));
var _about = _interopRequireDefault(require("./about.html"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var firstRun = true;
var ctor = {
  data: function data() {
    return {
      about_open: false
    };
  },
  computed: {
    networks: function networks() {
      return this.$state.networks;
    },
    aboutContent: function aboutContent() {
      return _about.default;
    }
  },
  methods: {
    addNetwork: function addNetwork() {
      var nick = 'Guest' + Math.floor(Math.random() * 100);
      var network = this.$state.addNetwork(TextFormatting.t('new_network'), nick, {});
      network.showServerBuffer('settings');
    },
    toggleStateBrowser: function toggleStateBrowser() {
      this.$state.$emit('statebrowser.show');
    },
    init: function init() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.$state.persistence.watchStateForChanges();
              _this.$emit('start', {
                fallbackComponent: _this.constructor
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (firstRun) {
              this.init();
              firstRun = false;
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};
var _default = ctor;
exports.default = _default;
(0, _state.default)().getStartups().kiwiirccom = ctor;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["thirdparty"]) window._kiwi_exports["thirdparty"] = {};
window._kiwi_exports["thirdparty"]["kiwiirccom"]
window._kiwi_exports.thirdparty.kiwiirccom = exports.default ? exports.default : exports;
